import React from 'react';
import { VisitCounter } from './VisitCounter';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="py-10 px-6 border-t border-zinc-900" data-id="element-59">
      <div className="max-w-6xl mx-auto flex flex-col items-center gap-6" data-id="element-60">
        <VisitCounter data-id="element-61" />
        <div className="w-full flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-zinc-600" data-id="element-62">
          <p data-id="element-63">© {new Date().getFullYear()} danceforfans.com</p>
          <div className="flex items-center gap-4" data-id="element-64">
            <span data-id="element-65">{t('common.conceptInProgress')}</span>
            <span className="w-1 h-1 rounded-full bg-zinc-800" data-id="element-66" />
            <a href="mailto:jose@danceforfans.com" className="hover:text-zinc-400 transition-colors" data-id="element-67">
              {t('common.contact')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}